import { useEffect } from 'react';

export const useForceFocus = (ref: React.RefObject<HTMLElement>, shouldForce?: boolean): void => {
  useEffect(() => {
    if(shouldForce && ref.current) {
      ref.current.focus();
    }
  }, [shouldForce, ref.current]);
};
